module.exports = __webpack_public_path__ + "static/media/ic-add-to-photos-active.40f78639.svg";